import type {
  ParameterID,
} from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Move a category
 *
 * @endpoint POST /api/me/item_categories/{internal_id}/move
 * @scope saas
 * @see https://flecto.dev/api-4724138
 */

export async function moveItemCategory(internal_id: ParameterID, offset: number): Promise<void> {
  await api.post(`/api/me/item_categories/${internal_id}/move`, { offset })
}
